import { parseDate as parseDate$1 } from '@internationalized/date';
/**
 * Takes string date in format yyyy-MM-dd and returns DateValue
 *
 * @param dateString
 */

var parseDate = function parseDate(dateString) {
  return parseDate$1(dateString);
};

export { parseDate };